module.exports = __webpack_public_path__ + "img/1356.c9226790.gif";